import { Box, Typography } from "@mui/material";
import React from "react";
import Strings from "../../utils/stringUtil";
import styles from "../../assets/styles/aditi.module.css";
import { isMobile } from "../../utils/responsiveUtil";
import AppIcons from "../../utils/appIcons";

function Disclaimer({ disclaimerText }) {
  return (
    <Box py={5} px={2} mt={4} className={styles.horizontalLine}>
      <Typography className={styles.disclaimerTitle}>
        {Strings.disclaimer}
      </Typography>
      <Typography className={styles.disclaimerDesc}>
        {disclaimerText}
      </Typography>
    </Box>
  );
}

export default Disclaimer;
